import styled, { css, keyframes } from 'styled-components';

import { TransparentButton } from 'src/app/components/Elements/Button/TransparentButton';

const collapseAnimation = keyframes`
  0% {
      opacity: 1;
      height: 100%;
      max-height: 60rem;
  }
  100% {
      opacity: 0;
      height: 0%;
      max-height: 0;
  }
`;

export const CallToActionAnimationContainer = styled.div<{ animateCollapse: boolean }>`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 5.2rem; /** if this changes, please fix the CSS variable in Medication/styles.module.scss */
  width: 100%;
  animation: ${props =>
    props.animateCollapse &&
    css`
      ${collapseAnimation} 0.2s linear
    `};
  animation-fill-mode: forwards;
  overflow: hidden;
  border-top: 1px solid ${props => props.theme.colors.capsuleGreen10};
`;

export const CallToActionButton = styled(TransparentButton)`
  background-color: ${props => props.theme.colors.capsuleGreen00} !important;
  height: 100%;
  width: 100%;
  text-align: center;
`;
